import { render } from "./PostCardComponent.vue?vue&type=template&id=aae08546&scoped=true"
import script from "./PostCardComponent.vue?vue&type=script&lang=js"
export * from "./PostCardComponent.vue?vue&type=script&lang=js"

import "./PostCardComponent.vue?vue&type=style&index=0&id=aae08546&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aae08546"]])

export default __exports__